import styled from 'styled-components'
import { device } from 'Styled/variables'

export const ChangeSpotifyBlockDesktop = styled.div`
  position: absolute;
  right: 24px;
  top: 39px;
`

export const ChangeSpotifyBlockMobile = styled.div`
  position: absolute;
  left: 72px;
  bottom: 25px;
  margin-top: 10px;
`

export const AddTrackWrapper = styled.div`
  position: static;
  margin-top: 0px;
  margin-left: 0;
  @media ${device.mobileMin} {
    position: relative;

    /* margin-left: 65px; */
  }
`

export const WrapperRelative = styled.div`
  z-index: 1;
  position: absolute;
  top: 56px;
  width: 512px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
`

export const WrapperForCloseBtn = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`
export const SmallButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    height: 10px;
  }
`
